/**
 * Tesco Default Theme
 * @author    Demetrios Yannikakis <demetrios.yannikakis@redboxdigital.com>
 * @copyright Copyright (c) 2020 Redbox Digital (http://www.redboxdigital.com)
 */
define('Magento_Checkout/js/cart/cart-crossells',[
    'jquery',
    'jquery/match-height',
    'domReady!'
], function ($) {
    'use strict';

    $.widget('tescomobile.crossells', {
        options: {},

        _create: function () {
            this._crossellsInit(this.options);
        },

        _crossellsInit: function () {
            let productItemName = '.product-item-name';
            
            $('.product-items').on('init', function(event, slick){
                $(productItemName).matchHeight();
            });

            window.addEventListener('resize', $(productItemName).matchHeight(), false);
            window.addEventListener('orientationchange', $(productItemName).matchHeight());
        }
    });

    return $.tescomobile.crossells;
});

